import { render, staticRenderFns } from "./LanguageDialog.vue?vue&type=template&id=dfc4e4a8&"
import script from "./LanguageDialog.vue?vue&type=script&lang=js&"
export * from "./LanguageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports